import React from "react";
import { StyleSheet, TouchableOpacity, Text, Platform } from "react-native";
import ImageComponent from "../ImageComponent";
import ElementSmileyIcon from "../icons/elements/ElementSmileyIcon";
import AppTheme from "../../AppTheme";
import TickIcon from "../icons/checkbox/TickIcon";

export default function ManaDropdownItem({
  item,
  onItemSelected = () => {},
  style = {},
  field = "name",
  hideIcon = false,
  isSelected = false,
  isListItem = false,
}) {
  return (
    <TouchableOpacity
      onPress={() => onItemSelected(item)}
      style={[styles.item, style]}
    >
      {hideIcon ? null : item.icon ? (
        <ImageComponent icon={item.icon} style={styles.icon} />
      ) : (
        <ElementSmileyIcon style={styles.icon} width="20" height="20" />
      )}
      <Text
        numberOfLines={1}
        style={[
          styles.itemText,
          styles.wordOverflow,
          isListItem && !isSelected ? { color: "#8B92A1" } : {},
        ]}
      >
        {item[field]}
      </Text>
      {isSelected ? <TickIcon /> : null}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  item: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: 32,
    paddingHorizontal: 8,
  },
  itemText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    maxWidth: "95%",
    flex: 1,
  },
  wordOverflow: Platform.select({
    ios: {
      overflow: "hidden",
      display: "flex",
    },
    web: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "pre",
    },
  }),
  icon: {
    width: 20,
    height: 20,
    marginRight: 6,
  },
});
